import React, { useEffect, useState } from 'react'
import Container from '../../components/Container';
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import DataFetching from "../../helper/DataFetching";
import renderDataTable from "../../helper/renderDataTable";
import Breadcrumb from '../../components/Breadcrumb';
import DatePicker from "react-datepicker";
import { SearchClear, onBlurDate, onFocusDate, submitDATE, tableDATE } from '../../helper/CommonFunction';
import { SiSololearn } from "react-icons/si";

const UserDomain = () => {
    const location = useLocation();
    const path = location.pathname.split('/')[3]

    const token = useSelector((state) => state.user.userToken)

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [activeTab, setActiveTab] = useState(0);
    const [filteredData, setFilteredData] = useState([]);
    const [pending, setPending] = useState(true);
    const [resetSearch, setResetSearch] = useState(true);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageLimit, setPageLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(0);

    const [form_date, setForm_date] = useState(null);
    const [end_date, setEnd_date] = useState(null);
    const [form_date1, setForm_date1] = useState(form_date ? "" : '');
    const [end_date1, setEnd_date1] = useState(end_date ? "" : '');
    const [hide, setHide] = useState('')
    const [from, setFrom] = useState(false);

    const [user, setUser] = useState({
        domain_name: '',
        email: '',
        user_id: '',
        domain_id: '',
        user_name: '',
    })

    const { domain_name, email, user_id, domain_id, user_name } = user;

    const onInputChange = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value });
    }


    const fetchData = async (tabId = activeTab) => {
        setPending(true);

        let type;
        switch (tabId) {
            case 0:
                type = "";
                break;
            case 1:
                type = "1";
                break;
            case 2:
                type = "0";
                break;
            case 3:
                type = "2";
                break;
            default:
                type = "";
                break;
        }

        const body = {
            page: currentPage - 1,
            perpage: pageLimit,
            domain_name: domain_name,
            email: email,
            user_id: user_id,
            domain_id: domain_id,
            user_name: user_name,
            status: type,
            start_date: form_date1,
            end_date: end_date1,
        }

        DataFetching(setPending, '/get_domain.php', 'POST', token, dispatch, navigate, setFilteredData, setTotalPages, body, setResetSearch, resetSearch);
    };

    const handleTabClick = (tabId) => {
        setCurrentPage(1);
        setActiveTab(tabId);
        fetchData(tabId);
    };

    const handleSearchClick = () => {
        if (form_date) {
            if (!end_date) {
                setHide("This field is required")
                return;
            }
        }
        if (hide || from) {
            return;
        }

        setCurrentPage(1);
        setResetSearch((prevReset) => !prevReset);
    };

    const handleClearSearch = () => {
        setHide('')
        setFrom(false);
        clearSearchData();
        setResetSearch((prevReset) => !prevReset);
    }

    const clearSearchData = () => {
        setUser({
            domain_name: '',
            email: '',
            user_id: '',
            domain_id: '',
            user_name: '',
        });

        setCurrentPage(1);
        setPageLimit(10)
        setForm_date(null);
        setForm_date1("");
        setEnd_date(null);
        setEnd_date1("");
        setActiveTab(0);
    };

    // Render the DataTable component
    useEffect(() => {
        if (!resetSearch) {
            return;
        }
        fetchData();
    }, [currentPage, pageLimit, location, resetSearch]);

    const revenueUsers = (row) => {
        navigate(`/admin/users/domains/${row.id}/${row.user_id}/revenue`)
    }

    const column = [
        {
            name: "App Name",
            selector: (row) => row.app_name,
        },
        {
            name: "User Id",
            selector: (row) => row.user_id,
            width: '14%'
        },
        {
            name: "App Url",
            selector: (row) => <Link to={row.domain_name} target='_blank' className='underline text-orange-500 border-b border-orange-100'>{row.domain_name}</Link>,
        },
        {
            name: "User Name",
            selector: (row) => row.full_name,
        },
        {
            name: "User Email",
            selector: (row) => row.email,
        },
        {
            name: "Actions",
            selector: row => (
                <div>
                    <button
                        onClick={() => revenueUsers(row)}
                        title='Add Revenue'
                        className='rounded-[3px] mr-1 mb-1 font-normal border-solid text-[13px] text-white bg-[#f97316] hover:bg-[#ea580c] transition-colors duration-200'
                        style={{ padding: '5px 6px' }}>
                        <SiSololearn size={14} className="text-white" />
                    </button>
                </div>
            ),
            width: '10%'
        },
    ]

    return (
        <>
            <Breadcrumb pageName="Domain History" />
            <Container>
                <div className="border-2 border-solid border-orange-100 bg-white w-full">
                    <div className='p-3 w-full'>
                        <div className='bg-white w-full px-3 table-custom-filters'>
                            <p className="text-lg font-medium py-[1%]">Filters:</p>
                            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 w-full gap-2'>
                                <div>
                                    <label>By App Id</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="domain_id"
                                        id="domain_id"
                                        value={domain_id}
                                        onChange={(e) => onInputChange(e)}
                                        placeholder="App Url ID"
                                    />
                                </div>
                                <div>
                                    <label>By User ID</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="user_id"
                                        id="user_id"
                                        value={user_id}
                                        onChange={(e) => onInputChange(e)}
                                        placeholder="User ID"
                                    />
                                </div>
                                <div>
                                    <label>By Domain Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="domain_name"
                                        id="domain_name"
                                        value={domain_name}
                                        onChange={(e) => onInputChange(e)}
                                        placeholder="Domain Name"
                                    />
                                </div>
                                <div>
                                    <label>By User Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="user_name"
                                        id="user_name"
                                        value={user_name}
                                        onChange={(e) => onInputChange(e)}
                                        placeholder="User Name"
                                    />
                                </div>
                                <div>
                                    <label>By Email</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        name="email"
                                        id="email"
                                        placeholder="Email"
                                        value={email}
                                        onChange={(e) => onInputChange(e)}
                                    />
                                </div>
                                <div className="relative">
                                    <label>From Start Date</label>
                                    <DatePicker
                                        selected={form_date}
                                        placeholderText="From Start Date"
                                        className={`form-control required ${from ? "is-invalid" : ""}`}
                                        onChange={(date) => tableDATE(date, setForm_date, setForm_date1, end_date, setFrom)}
                                        dateFormat="yyyy-MM-dd"
                                        onFocus={() => onFocusDate(setHide)}
                                        onBlur={() => onBlurDate(setHide, form_date, end_date)}
                                        data-placement="bottom-start"
                                    />
                                </div>
                                <div className="relative">
                                    <label>To End Date</label>
                                    <DatePicker
                                        selected={end_date}
                                        onChange={(date) => {
                                            submitDATE(
                                                date, setHide, setEnd_date, setEnd_date1, setFrom, form_date
                                            )
                                        }}
                                        dateFormat="yyyy-MM-dd"
                                        placeholderText="To End Date"
                                        className={`form-control required ${hide ? "is-invalid" : ""}`}
                                        minDate={form_date}
                                        data-placement="bottom-start"
                                    />
                                    {hide && <div style={{ color: 'red', display: 'block', fontWeight: '500' }}>{hide}</div>}
                                </div>
                            </div>
                            <div className='w-full block'>
                                <SearchClear search={handleSearchClick} clear={handleClearSearch} />
                            </div>
                        </div>
                        <div className='py-3'>
                            {renderDataTable(
                                filteredData,
                                column,
                                pending,
                                currentPage,
                                setPageLimit,
                                setCurrentPage,
                                totalPages,
                                pageLimit,
                                setResetSearch,
                                dispatch,
                                navigate,
                            )}
                        </div>
                    </div>
                </div>
            </Container>
        </>
    )
}

export default UserDomain;
